import React from 'react';
import Dropdown from '../../components/UI/Dropdown/Dropdown';

export default function vrstaIzvjestajaOptions(props) {

    let dropdownOptions = props.vrsteIzvjestaja.map(element => (
        <option key={element.id} value={element.id}>
            {element.name}
        </option>
    ))

  return (
    <>
        <Dropdown 
            hidden
            value={props.izvjestajParams.vrstaIzvjestaja}
            onChange={props.dropdownVrIzvjHandler}
            asProperty="select"
            map={dropdownOptions}
            text="Vrsta izvještaja"
            label="Odaberite vrstu izvještaja*"
            id="vrIzvjestaja"
        />
    </>
  );
}
